import React from "react";
import Accordion from "@mui/material/Accordion";
import AccordionSummary from "@mui/material/AccordionSummary";
import AccordionDetails from "@mui/material/AccordionDetails";
import { IFormGroupWrapperProps } from "./CheckoutAccordion.interfaces";

const CheckoutAccordion: React.FC<IFormGroupWrapperProps> = ({
    title,
    children,
    defaultExpanded,
    expanded,
    showExpandIcon,
    expandIcon,
    classes,
    headerClasses,
    detailsClasses,
    className,
    disabled,
    onTitleClick = () => {},
    unmountOnExit,
}) => {
    return (
        <Accordion
            defaultExpanded={defaultExpanded}
            classes={classes}
            className={className}
            disabled={disabled}
            expanded={expanded}
            //
            // By default, even when an accordian is not expanded,
            // MUI's default behaviour case the Accordian component to be rendered in dom, This prop 'unmountOnExit'
            // prevents the same
            TransitionProps={{ unmountOnExit }}
        >
            {title && (
                <AccordionSummary
                    expandIcon={showExpandIcon && expandIcon}
                    classes={headerClasses}
                    onClick={onTitleClick}
                >
                    {title}
                </AccordionSummary>
            )}
            <AccordionDetails classes={detailsClasses}>
                {children}
            </AccordionDetails>
        </Accordion>
    );
};

export default CheckoutAccordion;
